module.exports = __webpack_public_path__ + "img/terms-and-conditions.c59c2777.svg";